<template>
  <StaffList v-bind="$props" />
</template>

<script>
import StaffList from '@/components/StaffList';

export default {
  name: 'StaffTab',

  components: {
    StaffList,
  },

  props: ['distributor_id', 'subdistributor_id', 'chain_id', 'store_id'],
};
</script>
